import { OrgTestEmailType } from "gql/generated";

export const ALL_ORG_TEST_EMAIL_TYPES: OrgTestEmailType[] = [
  OrgTestEmailType.OperatorInvite,
  OrgTestEmailType.PingAgain,
  OrgTestEmailType.SignUpInvite,
  OrgTestEmailType.SignInInvite,
  OrgTestEmailType.Freshen,
];

export type OrgTestEmailTypeConfig = {
  value: OrgTestEmailType;
  labelKey: string;
};

export const ORG_TEST_EMAIL_TYPE_CONFIG: OrgTestEmailTypeConfig[] = [
  {
    value: OrgTestEmailType.OperatorInvite,
    labelKey: "TYPES.OPERATOR_INVITE",
  },
  {
    value: OrgTestEmailType.PingAgain,
    labelKey: "TYPES.PING_AGAIN",
  },
  {
    value: OrgTestEmailType.SignUpInvite,
    labelKey: "TYPES.SIGN_UP_INVITE",
  },
  {
    value: OrgTestEmailType.SignInInvite,
    labelKey: "TYPES.SIGN_IN_INVITE",
  },
  {
    value: OrgTestEmailType.Freshen,
    labelKey: "TYPES.FRESHEN",
  },
];
